import { createClient } from '@supabase/supabase-js'

// Replace these with your actual Supabase project credentials
// You can get these from https://supabase.com/dashboard/project/[your-project]/settings/api
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)